import { render, staticRenderFns } from "./SeoFields.vue?vue&type=template&id=893761e4&scoped=true&"
import script from "./SeoFields.vue?vue&type=script&lang=js&"
export * from "./SeoFields.vue?vue&type=script&lang=js&"
import style0 from "./SeoFields.vue?vue&type=style&index=0&id=893761e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893761e4",
  null
  
)

export default component.exports